import React, { useEffect, useState } from 'react';
interface Heart {
  id: number;
  left: number;
  animationDuration: number;
  delay: number;
  scale: number;
}
export function FloatingHearts() {
  const [hearts, setHearts] = useState<Heart[]>([]);
  useEffect(() => {
    // Generate random hearts
    const newHearts = Array.from({
      length: 20
    }).map((_, i) => ({
      id: i,
      left: Math.random() * 100,
      animationDuration: 6 + Math.random() * 10,
      delay: Math.random() * 5,
      scale: 0.5 + Math.random() * 0.5 // Random size
    }));
    setHearts(newHearts);
  }, []);
  return <div className="fixed inset-0 pointer-events-none overflow-hidden z-0" data-id="element-1">
      <style data-id="element-2">
        {`
          @keyframes floatUp {
            0% {
              transform: translateY(100vh) scale(1);
              opacity: 0;
            }
            10% {
              opacity: 0.8;
            }
            100% {
              transform: translateY(-20vh) scale(1.2);
              opacity: 0;
            }
          }
        `}
      </style>
      {hearts.map(heart => <div key={heart.id} className="absolute bottom-0 text-pink-500/20" style={{
      left: `${heart.left}%`,
      fontSize: `${heart.scale * 2}rem`,
      animation: `floatUp ${heart.animationDuration}s linear infinite`,
      animationDelay: `${heart.delay}s`
    }} data-id="element-3">
          ♥
        </div>)}
    </div>;
}